// Spanish copy for the app's own fixed UI text.
//
// Deliberately separate from labels.es.js: that table translates catalog
// VALUES (category / section / playlist names, which are stored English keys
// and must never change), while this one translates the chrome around them.
// Without it the catalog rendered half-translated -- Spanish playlist titles
// under an English "Back to" / "See all" / "Category:".
//
// The key IS the English string. That keeps the JSX readable and makes an
// untranslated entry degrade to correct English instead of a blank or a raw
// identifier -- the same fallback rule ES_LABELS uses. The flip side: editing
// the English copy silently drops its translation, so change both together.
//
// Every entry that takes a variable puts it LAST ("Back to <section>"), which
// holds in both languages, so components interpolate by composition and this
// table needs no placeholder syntax.
//
// Not listed, because Spanish spells them the same: "video" / "videos".
const ES_UI = {
  // CatalogBrowser
  "Back to": "Volver a",
  "More in": "Más en",
  "No videos yet": "Aún no hay videos",
  "Check back soon — your playlists will appear here.":
    "Vuelve pronto: aquí aparecerán tus listas.",

  // PlaylistRow
  "See all": "Ver todo",
  "See all videos in": "Ver todos los videos de",

  // Landmark names (SectionNav, LanguageToggle)
  "Video sections": "Secciones de videos",
  "Video language": "Idioma de los videos",

  // VideoCard -- including the progress badge, whose English labels come
  // from getProgressData and are translated at the render site so that
  // util stays a pure, language-free calculation.
  "Category:": "Categoría:",
  Play: "Reproducir",
  "Not Started": "No iniciado",
  "In Progress": "En progreso",
  Completed: "Completado",
  Watched: "Visto",

  // VideoGrid empty state
  "No videos found": "No se encontraron videos",
  "Try a different search term or category.":
    "Prueba con otro término de búsqueda o categoría.",

  // VideoModal -- the player sheet: countdown overlay, info block, the
  // up-next/suggestions list, and the un-embeddable-video escape hatch.
  "Up next": "A continuación",
  Suggestions: "Sugerencias",
  "Playing in": "Comienza en",
  "Play now": "Reproducir ahora",
  Cancel: "Cancelar",
  "You’ve reached the end of this playlist.":
    "Has llegado al final de esta lista.",
  "No suggestions available.": "No hay sugerencias disponibles.",
  "No captions are available for this video.":
    "No hay subtítulos disponibles para este video.",
  "This video can’t play here. Watch it on YouTube, then come back to continue.":
    "Este video no se puede reproducir aquí. Míralo en YouTube y luego vuelve para continuar.",
  "Watch on YouTube": "Ver en YouTube",
  "Close video": "Cerrar video",
  "Loading player": "Cargando el reproductor",
  "Starting playback": "Iniciando la reproducción",
  Captions: "Subtítulos",

  // VideoModal -- transport controls. "Off" is the captions-menu entry, not a
  // general on/off; the sibling entries there are language names ("English" /
  // "Español"), which stay in their own language and so need no translation.
  "Loading video…": "Cargando el video…",
  Seek: "Barra de progreso",
  "Seek (rewind only)": "Barra de progreso (solo retroceder)",
  "Player loading": "Cargando el reproductor",
  Pause: "Pausar",
  Mute: "Silenciar",
  Unmute: "Activar sonido",
  // Composed with the rate between them: "Playback speed 1.5x, tap to change".
  "Playback speed": "Velocidad de reproducción",
  "tap to change": "toca para cambiar",
  Off: "Desactivados",
  Fullscreen: "Pantalla completa",
  "Exit fullscreen": "Salir de pantalla completa",

  // VideoDashboard search summary
  Showing: "Mostrando",
  result: "resultado",
  results: "resultados",
  for: "para",
  "No videos match": "Ningún video coincide con",
};

export default ES_UI;
